import { createAction } from '@reduxjs/toolkit';

// entrypoint actions
export const GET_SURVEYS = 'GET_SURVEYS';
export const GET_SURVEY = 'GET_SURVEY';
export const GET_PAGINATED_SURVEYS = 'GET_PAGINATED_SURVEYS';
export const GET_MINIMAL_SURVEYS = 'GET_MINIMAL_SURVEYS';
export const CREATE_SURVEY = 'CREATE_SURVEY';
export const UPDATE_SURVEY = 'UPDATE_SURVEY';
export const DELETE_SURVEYS = 'DELETE_SURVEYS';
export const SET_CURRENT_SURVEY = 'SET_CURRENT_SURVEY';
export const SET_COPY_CURRENT_SURVEY = 'SET_COPY_CURRENT_SURVEY';
export const UNSET_CURRENT_SURVEY = 'UNSET_CURRENT_SURVEY';
export const CLEAR_SURVEY_ERROR = 'CLEAR_SURVEY_ERROR';

export const CLEAR_SURVEY_STORE = 'CLEAR_SURVEY_STORE';

// async actions

export const UPDATE_SURVEY_HASH_FILTER = 'UPDATE_SURVEY_HASH_FILTER';
export const UPDATE_SURVEY_RESULTS_DETAILS = 'UPDATE_SURVEY_RESULTS_DETAILS';
export const UPDATE_EVENT_ID_FILTER = 'UPDATE_EVENT_ID_FILTER';
export const UPDATE_EVENT_ID_WITHOUT_EFFECTS = 'UPDATE_EVENT_ID_WITHOUT_EFFECTS';

export const GETTING_PAGINATED_SURVEYS = 'GETTING_PAGINATED_SURVEYS';
export const GETTING_PAGINATED_SURVEYS_SUCCEEDED =
  'GETTING_PAGINATED_SURVEYS_SUCCEEDED';
export const GETTING_PAGINATED_SURVEYS_FAILED =
  'GETTING_PAGINATED_SURVEYS_FAILED';

export const GETTING_MINIMAL_SURVEYS = 'GETTING_MINIMAL_SURVEYS';
export const GETTING_MINIMAL_SURVEYS_SUCCEEDED =
  'GETTING_MINIMAL_SURVEYS_SUCCEEDED';
export const GETTING_MINIMAL_SURVEYS_FAILED =
  'GETTING_MINIMAL_SURVEYS_FAILED';

export const GETTING_SURVEYS = 'GETTING_SURVEYS';
export const GETTING_SURVEYS_SUCCEEDED = 'GETTING_SURVEYS_SUCCEEDED';
export const GETTING_SURVEYS_FAILED = 'GETTING_SURVEYS_FAILED';

export const GETTING_SURVEY = 'GETTING_SURVEY';
export const GETTING_SURVEY_FAILED = 'GETTING_SURVEY_FAILED';
export const GETTING_SURVEY_SUCCEEDED = 'GETTING_SURVEY_SUCCEEDED';

export const CREATING_SURVEY = 'CREATING_SURVEY';
export const CREATING_SURVEY_SUCCEEDED = 'CREATING_SURVEY_SUCCEEDED';
export const CREATING_SURVEY_FAILED = 'CREATING_SURVEY_FAILED';

export const UPDATING_SURVEY = 'UPDATING_SURVEY';
export const UPDATING_SURVEY_SUCCEEDED = 'UPDATING_SURVEY_SUCCEEDED';
export const UPDATING_SURVEY_FAILED = 'UPDATING_SURVEY_FAILED';

export const DELETING_SURVEYS = 'DELETING_SURVEYS';
export const DELETING_SURVEYS_SUCCEEDED = 'DELETING_SURVEYS_SUCCEEDED';
export const DELETING_SURVEYS_FAILED = 'DELETING_SURVEYS_FAILED';

export const GET_SURVEY_RESULTS = 'GET_SURVEY_RESULTS';
export const GETTING_SURVEY_RESULTS = 'GETTING_SURVEY_RESULTS';
export const GETTING_SURVEY_RESULTS_SUCCEEDED =
  'GETTING_SURVEY_RESULTS_SUCCEEDED';
export const GETTING_SURVEY_RESULTS_FAILED = 'GETTING_SURVEY_RESULTS_FAILED';

export const GET_INDIVIDUAL_SURVEY_RESULTS = 'GET_INDIVIDUAL_SURVEY_RESULTS';
export const GETTING_INDIVIDUAL_SURVEY_RESULTS =
  'GETTING_INDIVIDUAL_SURVEY_RESULTS';
export const GETTING_INDIVIDUAL_SURVEY_RESULTS_SUCCEEDED =
  'GETTING_INDIVIDUAL_SURVEY_RESULTS_SUCCEEDED';
export const GETTING_INDIVIDUAL_SURVEY_RESULTS_FAILED =
  'GETTING_INDIVIDUAL_SURVEY_RESULTS_FAILED';

export const SAVE_SURVEY_LOGO = 'SAVE_SURVEY_LOGO';
export const SAVING_SURVEY_LOGO = 'SAVING_SURVEY_LOGO';
export const SAVING_SURVEY_LOGO_SUCCEEDED = 'SAVING_SURVEY_LOGO_SUCCEEDED';
export const SAVING_SURVEY_LOGO_FAILED = 'SAVING_SURVEY_LOGO_FAILED';
export const GET_SURVEY_LOGO_URL = 'GET_SURVEY_LOGO_URL';
export const GETTING_SURVEY_LOGO_URL_SUCCEEDED =
  'GETTING_SURVEY_LOGO_URL_SUCCEEDED';

export const SEND_SURVEY_RESULT_RESPONSE = 'SEND_SURVEY_RESULT_RESPONSE';
export const SEND_SURVEY_RESULT_RESPONSE_SUCCEEDED =
  'SEND_SURVEY_RESULT_RESPONSE_SUCCEEDED';
export const SEND_SURVEY_RESULT_RESPONSE_FAILED =
  'SEND_SURVEY_RESULT_RESPONSE_FAILED';

export const CLOSE_SENT_RESPONSE_SNACKBAR = 'CLOSE_SENT_RESPONSE_SNACKBAR';
export const SET_SURVEY_SETTINGS_DATA = 'SET_SURVEY_SETTINGS_DATA';
export const UNSET_SURVEY_SETTINGS_DATA = 'UNSET_SURVEY_SETTINGS_DATA';

export const GET_ASSOCIATED_CAMPAIGNS = 'GET_ASSOCIATED_CAMPAIGNS';
export const GETTING_ASSOCIATED_CAMPAIGNS = 'GETTING_ASSOCIATED_CAMPAIGNS';
export const GETTING_ASSOCIATED_CAMPAIGNS_SUCCEEDED =
  'GETTING_ASSOCIATED_CAMPAIGNS_SUCCEEDED';
export const GETTING_ASSOCIATED_CAMPAIGNS_FAILED =
  'GETTING_ASSOCIATED_CAMPAIGNS_FAILED';

export const GET_GUEST_DETAILS = 'GET_GUEST_DETAILS';
export const GETTING_GUEST_DETAILS = 'GETTING_GUEST_DETAILS';
export const GETTING_GUEST_DETAILS_SUCCEEDED =
  'GETTING_GUEST_DETAILS_SUCCEEDED';
export const GETTING_GUEST_DETAILS_FAILED = 'GETTING_GUEST_DETAILS_FAILED';

export const GET_SURVEY_RESULT_CSV_FILE = 'GET_SURVEY_RESULT_CSV_FILE';
export const GETTING_SURVEY_RESULT_CSV_FILE_SUCCEEDED = 'GETTING_SURVEY_RESULT_CSV_FILE_SUCCEEDED';
export const GETTING_SURVEY_RESULT_CSV_FILE_FAILED = 'GETTING_SURVEY_RESULT_CSV_FILE_FAILED';
export const DOWNLOADED_SURVEY_RESULT_CSV_FILE = 'DOWNLOADED_SURVEY_RESULT_CSV_FILE';

export const UPDATE_SURVEY_FILTERS = 'UPDATE_SURVEY_FILTERS';
export const RESET_SURVEY_FILTERS = 'RESET_SURVEY_FILTERS';
export const UPDATE_INDIVIDUAL_SURVEY_RESULT_FILTERS = 'UPDATE_INDIVIDUAL_SURVEY_RESULT_FILTERS';
export const RESET_INDIVIDUAL_SURVEY_RESULT_FILTERS = 'RESET_INDIVIDUAL_SURVEY_RESULT_FILTERS';
export const UPDATE_SURVEY_RESULT_FILTERS = 'UPDATE_SURVEY_RESULT_FILTERS';
export const RESET_SURVEY_RESULT_FILTERS = 'RESET_SURVEY_RESULT_FILTERS';

export const getSurveys = createAction(GET_SURVEYS);

export const getSurvey = createAction(GET_SURVEY);

export const getPaginatedSurveys = createAction(GET_PAGINATED_SURVEYS);

export const getMinimalSurveys = createAction(GET_MINIMAL_SURVEYS);

export const createSurvey = createAction(CREATE_SURVEY);

export const updateSurvey = createAction(UPDATE_SURVEY);

export const deleteSurveys = createAction(DELETE_SURVEYS);

export const setCurrentSurvey = createAction(SET_CURRENT_SURVEY);

export const setCopyCurrentSurvey = createAction(SET_COPY_CURRENT_SURVEY);

export const unsetCurrentSurvey = createAction(UNSET_CURRENT_SURVEY);

export const clearSurveyError = createAction(CLEAR_SURVEY_ERROR);

export const clearSurveyStore = createAction(CLEAR_SURVEY_STORE);

export const updateSurveyHashFilter = createAction(UPDATE_SURVEY_HASH_FILTER);
export const updateSurveyResultsDetails = createAction(UPDATE_SURVEY_RESULTS_DETAILS);
export const updateEventIdFilter = createAction(UPDATE_EVENT_ID_FILTER);
export const updateEventIdWithoutEffects = createAction(UPDATE_EVENT_ID_WITHOUT_EFFECTS);

export const gettingPaginatedSurveys = createAction(GETTING_PAGINATED_SURVEYS);
export const gettingPaginatedSurveysSucceeded = createAction(
  GETTING_PAGINATED_SURVEYS_SUCCEEDED
);
export const gettingPaginatedSurveysFailed = createAction(
  GETTING_PAGINATED_SURVEYS_FAILED
);

export const gettingMinimalSurveys = createAction(GETTING_MINIMAL_SURVEYS);
export const gettingMinimalSurveysSucceeded = createAction(
  GETTING_MINIMAL_SURVEYS_SUCCEEDED
);
export const gettingMinimalSurveysFailed = createAction(
  GETTING_MINIMAL_SURVEYS_FAILED
);

export const gettingSurveys = createAction(GETTING_SURVEYS);

export const gettingSurveysSucceeded = createAction(GETTING_SURVEYS_SUCCEEDED);

export const gettingSurveysFailed = createAction(GETTING_SURVEYS_FAILED);

export const gettingSurvey = createAction(GETTING_SURVEY);

export const gettingSurveySucceeded = createAction(GETTING_SURVEY_SUCCEEDED);

export const gettingSurveyFailed = createAction(GETTING_SURVEY_FAILED);

export const creatingSurvey = createAction(CREATING_SURVEY);

export const creatingSurveySucceeded = createAction(CREATING_SURVEY_SUCCEEDED);

export const creatingSurveyFailed = createAction(CREATING_SURVEY_FAILED);

export const updatingSurvey = createAction(UPDATING_SURVEY);

export const updatingSurveySucceeded = createAction(UPDATING_SURVEY_SUCCEEDED);

export const updatingSurveyFailed = createAction(UPDATING_SURVEY_FAILED);

export const deletingSurveys = createAction(DELETING_SURVEYS);

export const deletingSurveysSucceeded = createAction(
  DELETING_SURVEYS_SUCCEEDED
);

export const deletingSurveysFailed = createAction(DELETING_SURVEYS_FAILED);

export const getSurveyResults = createAction(GET_SURVEY_RESULTS);

export const gettingSurveyResults = createAction(GETTING_SURVEY_RESULTS);

export const gettingSurveyResultsSucceeded = createAction(
  GETTING_SURVEY_RESULTS_SUCCEEDED
);

export const gettingSurveyResultsFailed = createAction(
  GETTING_SURVEY_RESULTS_FAILED
);

export const getIndividualSurveyResults = createAction(
  GET_INDIVIDUAL_SURVEY_RESULTS
);

export const gettingIndividualSurveyResults = createAction(
  GETTING_INDIVIDUAL_SURVEY_RESULTS
);

export const gettingIndividualSurveyResultsSucceeded = createAction(
  GETTING_INDIVIDUAL_SURVEY_RESULTS_SUCCEEDED
);

export const gettingIndividualSurveyResultsFailed = createAction(
  GETTING_INDIVIDUAL_SURVEY_RESULTS_FAILED
);

export const saveSurveyLogo = createAction(SAVE_SURVEY_LOGO);

export const savingSurveyLogo = createAction(SAVING_SURVEY_LOGO);

export const savingSurveyLogoSucceeded = createAction(
  SAVING_SURVEY_LOGO_SUCCEEDED
);

export const savingSurveyLogoFailed = createAction(SAVING_SURVEY_LOGO_FAILED);

export const getSurveyLogoUrl = createAction(GET_SURVEY_LOGO_URL);

export const gettingSurveyLogoUrlSucceeded = createAction(
  GETTING_SURVEY_LOGO_URL_SUCCEEDED
);

export const sendSurveyResultResponse = createAction(
  SEND_SURVEY_RESULT_RESPONSE
);

export const sendSurveyResultResponseSucceeded = createAction(
  SEND_SURVEY_RESULT_RESPONSE_SUCCEEDED
);

export const sendSurveyResultResponseFailed = createAction(
  SEND_SURVEY_RESULT_RESPONSE_FAILED
);

export const closeSentResponseSnackbar = createAction(
  CLOSE_SENT_RESPONSE_SNACKBAR
);

export const setSurveySettingsData = createAction(SET_SURVEY_SETTINGS_DATA);

export const unsetSurveySettingsData = createAction(UNSET_SURVEY_SETTINGS_DATA);

export const getAssociatedCampaigns = createAction(GET_ASSOCIATED_CAMPAIGNS);
export const gettingAssociatedCampaigns = createAction(
  GETTING_ASSOCIATED_CAMPAIGNS
);
export const gettingAssociatedCampaignsSucceeded = createAction(
  GETTING_ASSOCIATED_CAMPAIGNS_SUCCEEDED
);
export const gettingAssociatedCampaignsFailed = createAction(
  GETTING_ASSOCIATED_CAMPAIGNS_FAILED
);

export const getGuestDetails = createAction(GET_GUEST_DETAILS);
export const gettingGuestDetails = createAction(GETTING_GUEST_DETAILS);
export const gettingGuestDetailsSucceeded = createAction(
  GETTING_GUEST_DETAILS_SUCCEEDED
);
export const gettingGuestDetailsFailed = createAction(
  GETTING_GUEST_DETAILS_FAILED
);

export const getSurveyResultCsvFile = createAction(GET_SURVEY_RESULT_CSV_FILE);
export const gettingSurveyResultCsvFileSucceeded = createAction(GETTING_SURVEY_RESULT_CSV_FILE_SUCCEEDED);
export const gettingSurveyResultCsvFileFailed = createAction(GETTING_SURVEY_RESULT_CSV_FILE_FAILED);
export const downloadedSurveyResultCsvFile = createAction(DOWNLOADED_SURVEY_RESULT_CSV_FILE);
export const updateSurveyFilters = createAction(UPDATE_SURVEY_FILTERS);
export const resetSurveyFilters = createAction(RESET_SURVEY_FILTERS);
export const updateIndividualSurveyResultFilters = createAction(UPDATE_INDIVIDUAL_SURVEY_RESULT_FILTERS);
export const resetIndividualSurveyResultFilters = createAction(RESET_INDIVIDUAL_SURVEY_RESULT_FILTERS);
export const updateSurveyResultFilters = createAction(UPDATE_SURVEY_RESULT_FILTERS);
export const resetSurveyResultFilters = createAction(RESET_SURVEY_RESULT_FILTERS);